export const STATUS_ICONS = {
    success: "✅",
    warning: "⚠️",
    error: "❌",
};
